<template>
  <v-layout v-if="hasActivities" row wrap>
    <v-flex
      v-for="(item, index) in resource.form.student_activities_attributes"
      :key="`activity${index}`"
      xs12 md6 lg4>
      <h3>{{ getActivityName(item.activity_id) }}</h3>
      <p>{{item.schedule}}</p>
    </v-flex>
  </v-layout>

  <v-layout
    v-else
    align-center
    justify-center
    column>
    <h3>Não há registro de atividades.</h3>
    <h4 class="text-secondary mb-2">There is no record of activities.</h4>
  </v-layout>
</template>

<script>
import * as api from '@/api'

export default {
  name: 'FormStudentActivities',

  inject: ['resource'],

  data: () => ({
    activities: []
  }),

  computed: {
    hasActivities () {
      return this.resource.form.student_activities_attributes.length > 0
    }
  },

  mounted () {
    this.getActivities()
  },

  methods: {
    getActivities () {
      api.forms.information.getActivities()
        .then(({ data }) => {
          this.activities = data
        })
    },

    getActivityName (activityId) {
      return (this.activities.find(activity => activity.id === activityId) || {}).name
    }
  }
}
</script>
